import { Constants } from '@constants';
import { buildAddressLabel } from '@forms/autoAddress/AutoAddressHelper';
import { FormattedName } from '@iwIntlProvider/FormattedName';
import { IconAngleRight } from '@iwoca/icons';
import { Pill } from '@iwoca/orion';
import { Text } from '@iwoca/orion-ui';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { Card } from '@ui';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';

import { TPerson } from '../../../funding/fundingSteps/majorShareholderCheckAction/mshModal/MSHForm.types';

export const PersonCard = ({
    person: {
        isGuarantor,
        isApplicant,
        isDirector,
        isShareholder,
        firstName,
        lastName,
        dateOfBirth,
        addresses
    }
}: {
    person: TPerson;
}) => {
    return (
        <Card className="my-s">
            <div className="mb-l flex w-full flex-row justify-between">
                <div className="mt-m flex flex-row flex-wrap gap-m">
                    {isApplicant && (
                        <Pill variant="green" className="h-xl">
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.applicant"
                                defaultMessage="Applicant"
                            />
                        </Pill>
                    )}
                    {isGuarantor && (
                        <Pill variant="london" className="h-xl">
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.guarantor"
                                defaultMessage="Guarantor"
                            />
                        </Pill>
                    )}
                    {isDirector && (
                        <Pill variant="yellow" className="h-xl">
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.director"
                                defaultMessage="Director"
                            />
                        </Pill>
                    )}
                    {isShareholder ? (
                        <Pill variant="red" className="h-xl">
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.major_shareholder"
                                defaultMessage="Major Shareholder"
                            />
                        </Pill>
                    ) : (
                        <Pill className="bg-secondary-97 h-xl border border-secondary-80 text-structure-0">
                            <FormattedMessage
                                id="_.credit_card.onboarding.company_shareholders.not_major_shareholder"
                                defaultMessage="Not Major Shareholder"
                            />
                        </Pill>
                    )}
                </div>
            </div>
            <p className="mb-4 m-0">
                <FormattedName firstName={firstName} lastName={lastName} />
            </p>
            <p className="mb-4 m-0">
                {dateOfBirth?.year && dateOfBirth?.month && dateOfBirth?.day
                    ? format(
                          new Date(
                              parseInt(dateOfBirth.year),
                              parseInt(dateOfBirth.month) - 1,
                              parseInt(dateOfBirth.day)
                          ),
                          'dd/MM/yyyy'
                      )
                    : null}
            </p>
            {addresses?.[0] && (
                <p className="m-0">{buildAddressLabel(addresses![0])}</p>
            )}

            <div className="my-l">
                <NEW_IwLink to={{ pathname: '/company' }} className="mb-l">
                    <Text className="text-s font-med text-primary-40 underline">
                        <FormattedMessage
                            id="_.credit_card.onboarding.company_shareholders.edit"
                            defaultMessage="Add or edit this under your company profile"
                        />
                    </Text>
                    <IconAngleRight />
                </NEW_IwLink>

                <Text className="text-xs font-reg">
                    <FormattedMessage
                        id="_.credit_card.onboarding.company_shareholders.call_us"
                        defaultMessage="Still need assistance? Give us a call on <a>{phone}</a>."
                        values={{
                            phone: Constants.CREDIT_CARD_PHONE_NUMBER.display,
                            a: (chunks) => (
                                <a
                                    className="underline"
                                    href={
                                        Constants.CREDIT_CARD_PHONE_NUMBER.tel
                                    }
                                >
                                    {chunks}
                                </a>
                            )
                        }}
                    />
                </Text>
            </div>
        </Card>
    );
};
